import { C5EventForm } from "./form";

export function C5EventsNew() {
  return <C5EventForm isNew />;
}
